// assets
import { CalendarOutlined, ShopOutlined, ShoppingOutlined, BarChartOutlined, QuestionOutlined, UsergroupDeleteOutlined } from '@ant-design/icons';
import { reactLocalStorage } from 'reactjs-localstorage';

// icons
const icons = {
  CalendarOutlined,
  ShopOutlined,
  ShoppingOutlined,
  BarChartOutlined,
  QuestionOutlined, 
  UsergroupDeleteOutlined
};

const setting = {
    id: 'setting',
    title: 'Settings',
    type: 'group',
    children: [
      {
        id: 'event',
        title: 'Event',
        type: 'item',
        url: '/event',
        icon: icons.CalendarOutlined,
        breadcrumbs: true
        // target: true
      },
      {
        id: 'admin',
        title: 'Admin',
        type: 'item',
        url: 'setting/admins',
        icon: icons.UsergroupDeleteOutlined,
        breadcrumbs: true
      },
    ]
  };

export default setting;